export default __webpack_public_path__ + "static/media/DSC06032.4df17b06.jpg";